import { AlertCircle, ArrowUpRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Alert, AlertTitle, AlertDescription } from '@/components/atoms/alert';
import { Button } from '@/components/atoms/button';
import { cn } from '@/lib/utils';

interface LimitReachedAlertProps {
  type: 'shop' | 'product';
  limit: number;
  onUpgrade?: () => void;
  className?: string;
}

export function LimitReachedAlert({
  type,
  limit,
  onUpgrade,
  className,
}: LimitReachedAlertProps) {
  const { t } = useTranslation();

  const typeLabel = t(`subscription.limits.${type}`);

  return (
    <Alert variant="destructive" className={cn('flex flex-col gap-3', className)}>
      <AlertCircle className="size-4" />
      <AlertTitle>{t('subscription.limitReached')}</AlertTitle>
      <AlertDescription>
        {t('subscription.limitReachedDescription', {
          type: typeLabel,
          limit,
        })}
      </AlertDescription>
      {onUpgrade && (
        <Button
          variant="outline"
          size="sm"
          onClick={onUpgrade}
          className="w-fit"
        >
          {t('subscription.upgradeNow')}
          <ArrowUpRight className="size-4" />
        </Button>
      )}
    </Alert>
  );
}
